const toMinutes = (durationInSeconds)=>{
    const minutes = Math.floor(durationInSeconds / 60);
    if (minutes < 60) {
        const remainingSeconds = Math.ceil(durationInSeconds - 60 * minutes);
        if (0 === remainingSeconds) return `${minutes}m`;
        return `${minutes}m ${remainingSeconds}s`;
    }
    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
        const remainingMinutes = Math.ceil(minutes - 60 * hours);
        if (0 === remainingMinutes) return `${hours}h`;
        return `${hours}h ${remainingMinutes}m`;
    }
    const days = Math.floor(hours / 24);
    const remainingHours = Math.ceil(hours - 24 * days);
    return `${days}d ${remainingHours}h`;
};
const date_toMinutes = toMinutes;
export default date_toMinutes;
